/* istanbul ignore file */
export { default } from './Checkout';
